import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RptloanpopupComponent } from "../../../shared/popup/rptloanpopup/rptloanpopup.component";

import { CommonmastersService } from "../../../../commonmasters/commonmasters.service";
import { PrintcollectionsheetService } from "../../../shared/print/printcollectionsheet.service";

@Component({
  selector: 'app-rptcollectionsheetpopup',
  templateUrl: './rptcollectionsheetpopup.component.html',
  styleUrls: ['./rptcollectionsheetpopup.component.css']
})
export class RptcollectionsheetpopupComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<RptloanpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private CommonmastersService: CommonmastersService,
    private printcollectionsheetService: PrintcollectionsheetService,
    // public datePipe: DatePipe,
  ) { }

  BranchList: any[] = [];
  CentreList: any[] = [];

  ngOnInit() {

    this.GetBranch();
    // this.GetCentre();
  }

  GenerateReports(): void {
 
    this.data.ReportName = "CollectionReport";
    this.printcollectionsheetService.GetCollectionSheet(this.data);
    this.dialogRef.close();
  }

  GetBranch() {
    this.CommonmastersService.GetBranchList().subscribe(data => {
      this.BranchList = data;

      // data.BranchId = 0;
      this.data.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];

      //auto selecting the centre based on branch selected.
      this.CentreList = [];
      this.SelectCentre(this.data.BranchId);
    })
  }

  // GetCentre() {
  //   this.CommonmastersService.FetchCenterList().subscribe(data => {
  //     this.CentreList = data;

  //     data.CentreId =0;
  //   })
  // }

  SelectCentre(branchId: any) {
      this.CommonmastersService.FetchCentersBybranchId(branchId).subscribe(data => {
        this.CentreList = data;
      })

  }

}
